<script setup>
import { defineEmits, onMounted, defineExpose } from 'vue';
import requests from '@dk.onlinefundraising/onboarding-utils/src/OfOnboardingRequests';
import { merchant, merchants } from '@/store';
import { setPage, reloader, currentPage } from '@dk.onlinefundraising/onboarding-utils/src/pageHandler';
import { userAllowed } from '@/functions';

const emit = defineEmits(['logout'])

defineExpose({
    getMerchants
});

function showSubMenu(e) {
    const target = e.currentTarget

    if (!target.classList.contains('active')) {

        document.querySelectorAll('.primary-menu ul>li:not(.active) .sub-menu').forEach(element => {
            element.style.display = 'none';
        })

        const position = target.getBoundingClientRect()

        target.children[1].style.display = 'block';
        target.children[1].style.top = position.top + 'px';
        target.children[1].style.width = '0';
        target.children[1].style.left = '200px';

        setTimeout(() => {
            target.children[1].style.width = '230px';
        }, 10)

        const element = document.getElementById("nav-left");
        const buffer = element.offsetHeight - position.top - 230

        if (buffer < 0) {
            target.children[1].style.top = (position.top + buffer) + 'px';
        }
    }
}
function closeSubMenu() {
    document.querySelectorAll('.primary-menu ul>li:not(.active) .sub-menu').forEach(element => {
        element.style.display = 'none';
    })
}
function getMerchants() {
    requests.getMerchants().then((result) => {
        merchants.value = result;
    });
}
function changeMerchant(selectedMerchant, page) {

    merchant.value = selectedMerchant;

    if (page) {
        setPage(page);
    } else {
        setPage(null);
    }

    sessionStorage.setItem('merchantId', selectedMerchant.merchantId);

    reloader.value++;

}
function viewUsers() {

    merchant.value = {};

    setPage('users');

}
onMounted(() => {
    getMerchants();
})
</script>

<template>
    <div class="brand">

    </div>
    <div class="nav-wrap">
        <nav class="primary-menu">
            <ul v-if="merchants.length">
                <li v-for="merchantOption in merchants" :key="merchantOption.merchantId"
                    :class="{ active: merchantOption.merchantId == merchant.merchantId }"
                    @click="changeMerchant(merchantOption)" @mouseover="showSubMenu" @mouseleave="closeSubMenu">

                    <span>
                        {{ merchantOption.name }}
                    </span>

                    <div class="sub-menu" @mouseover.stop>
                        <ul class="merchants-entities">
                            <li v-if="userAllowed('READ_LEAD')" @click.stop="changeMerchant(merchantOption, 'leads')"
                                :class="{ active: merchantOption.merchantId == merchant.merchantId && currentPage == 'leads' }">
                                Leads </li>
                            <li v-if="userAllowed('READ_SESSION')"
                                @click.stop="changeMerchant(merchantOption, 'sessions')"
                                :class="{ active: merchantOption.merchantId == merchant.merchantId && currentPage == 'sessions' }">
                                Sessions </li>
                            <li v-if="userAllowed('READ_CAMPAIGN')"
                                @click.stop="changeMerchant(merchantOption, 'campaigns')"
                                :class="{ active: merchantOption.merchantId == merchant.merchantId && currentPage == 'campaigns' }">
                                Campaigns </li>
                            <li v-if="userAllowed('READ_WORKFLOW')"
                                @click.stop="changeMerchant(merchantOption, 'workflows')"
                                :class="{ active: merchantOption.merchantId == merchant.merchantId && currentPage == 'workflows' }">
                                Workflows</li>
                        </ul>
                    </div>

                </li>
            </ul>
        </nav>
        <nav class="support-menu">
            <ul v-if="userAllowed('READ_USER')">
                <li @click.prevent="viewUsers">
                    <div>
                        <a target="_blank">
                            Users
                        </a>
                    </div>
                </li>
            </ul>
            <ul class="logout">
                <li>
                    <div>
                        <button type="button" @click="emit('logout')">
                            Log out
                        </button>
                    </div>
                </li>
            </ul>
        </nav>
    </div>
</template>

<style scoped>
.brand {
    height: 72px;
    color: #fff;
    background-color: transparent;
    position: sticky;
    top: 0;
    font-size: 40px;
    font-weight: 700;
    line-height: 72px;
    text-align: center;
    text-transform: uppercase;
}

ul {
    list-style: none
}

.nav-wrap {
    display: flex;
    flex-flow: column nowrap;
    max-height: calc(100vh - 72px);
    height: calc(100vh - 72px);
    overflow-x: hidden;
    overflow-y: auto;
}

.primary-menu ul,
.support-menu ul {
    width: 100%;
}

.primary-menu ul>li,
.support-menu ul>li {
    align-items: center;
    color: #fff;
    font-weight: 500;
    display: flex;
    font-size: 12px;
    width: auto;
    line-height: 1.2em;
    cursor: pointer;
}

.primary-menu ul>li>span {
    display: block;
    width: 100%;
    padding: 15px 10px 15px 20px;
}

.primary-menu ul>li.active>span {
    background: linear-gradient(45deg, rgba(15, 91, 194, .9), rgba(58, 177, 230, .9));
}

.support-menu {
    border-top: 1px solid hsla(0, 0%, 100%, .2);
    padding: 10px 0;
}

.support-menu ul li {
    padding: 10px 20px;
}

.sub-menu {
    transition: width .2s;
}

.primary-menu ul>li.active .sub-menu {
    display: block !important;
}

.primary-menu ul>li:not(.active):not(:hover) .sub-menu {
    display: none !important;
}

.primary-menu ul>li .sub-menu li {
    display: block;
    width: 100%;
    padding: 10px 0 10px 40px;
}

.primary-menu ul>li.active .sub-menu li.active {
    background: linear-gradient(45deg, rgba(15, 91, 194, .9), rgba(58, 177, 230, .9));
}

.logout div {
    width: 100%;
}

.support-menu a {
    color: #fff;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 500;
    text-decoration: none;
}

.logout button {
    color: #fff;
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 500;
    background: transparent;
    border: none;
    padding: 0;
    text-align: left;
    display: block;
    width: 100%;
    cursor: pointer;
}

.primary-menu ul>li:not(.active) .sub-menu {
    position: absolute;
    z-index: 10;
    display: none;
    background: #212121;
}

.primary-menu>ul>li.active {
    height: 100%;
    display: block;
}
</style>